import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../../hooks/snackBar";
import PerfilSellerListOportunidadeLog from "./ListLog";
import { saveAs } from "file-saver";
import {
  gerarExelModeloImportacao,
  importacaoOportunidades,
  listarLogOportunidades,
  exportacaoResultadoLog,
  importacaoOportunidadesValidar,
} from "../../../../services/http/oportunidadeService";

import "./styles.scss";
import { Dialog } from "@material-ui/core";
import { Box, Typography } from "@mui/material";

const PerfilSellerImportacaoOportunidade = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const [voltou, setVoltou] = useState(false);
  const [documento, setDocumento] = useState(null);
  const stateRef = useRef();
  stateRef.current = voltou;
  const hiddenFileInput = React.useRef(null);
  const [confirmTotal, setConfirmTotal] = useState(0);
  const [logOportunidades, setLogOportunidades] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const carregarListaOportunidadeLog = (pagina) => {
    trackPromise(
      listarLogOportunidades(pagina).then((res) => {
        if (res.data) {
          setLogOportunidades(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar logs",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar logs",
        info: "error",
        open: true,
      });
    });
  };

  const gerarModeloBaseImportacao = () => {
    trackPromise(
      gerarExelModeloImportacao().then((res) => {
        if (res.data) {
          saveAs(res.data, "oportunidade-modelo.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível baixar modelo base",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar baixar modelo base",
        info: "error",
        open: true,
      });
    });
  };

  const exportarResultadoLogOportunidade = (tipoLogResultado, idLog) => {
    trackPromise(
      exportacaoResultadoLog(tipoLogResultado, idLog).then((res) => {
        if (res.data) {
          saveAs(res.data, "log-oportunidade.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível baixar modelo base",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar baixar modelo base",
        info: "error",
        open: true,
      });
    });
  };

  const importarArquivo = (somenteUmaOportunidade = false) => {
    var emailUsuario = JSON.parse(sessionStorage.getItem("authSistema")).email;
    trackPromise(
      importacaoOportunidades(emailUsuario, documento, false).then((res) => {
        setConfirmTotal(0);
        setDocumento(null);
        if (!res.fail) {
          addSnackBar({
            message: "Importado com sucesso",
            info: "success",
            open: true,
          });
          carregarListaOportunidadeLog(1);
        } else {
          addSnackBar({
            message: "Não foi possível importar oportunidades",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      setConfirmTotal(0);
      setDocumento(null);
      addSnackBar({
        message: "Erro ano tentar importar oportunidades",
        info: "error",
        open: true,
      });
    });
  };

  const importarArquivoValidar = () => {
    var emailUsuario = JSON.parse(sessionStorage.getItem("authSistema")).email;
    trackPromise(
      importacaoOportunidadesValidar(emailUsuario, documento).then((res) => {
        if (!res.fail) {
          if (res.data <= 1) {
            importarArquivo();
          } else {
            setConfirmTotal(res.data);
          }
        } else {
          addSnackBar({
            message: "Não foi possível importar oportunidades",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar importar oportunidades",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaFilialSeller = (page) => {
    carregarListaOportunidadeLog(page);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleUpload = (event) => {
    var file = event.target.files[0];

    if (!file) {
      setDocumento(null);
      return;
    }

    if (!file.name.endsWith(".xlsx")) {
      addSnackBar({
        message: 'Você deve selecionar um arquivo com extensão ".xlsx"',
        info: "warning",
        open: true,
      });
      setDocumento(null);
      return;
    }

    setDocumento(file);
  };

  useEffect(() => {
    carregarListaOportunidadeLog(1);
  }, []);

  return (
    <div>
      <div className="row">
        <h1 className="col-sm-12 col-md-12 col-lg-12 titulo">Oportunidades</h1>
      </div>

      <div className="row mt20 ml-1">
        <h1 className="label-second">Importação de Oportunidades</h1>
      </div>

      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mt20 mb-2">
          <input
            type="file"
            ref={hiddenFileInput}
            multiple
            style={{ display: "none" }}
            onChange={handleUpload}
          />

          <button
            className="button-anexar buton-green"
            type="file"
            style={{ width: "100%" }}
            onClick={handleClick}
          >
            ESCOLHER ARQUIVO
          </button>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3 mb-2">
          <button
            onClick={importarArquivoValidar}
            className="buton-white-black-border btn btn-block btn-lg"
            disabled={!documento}
          >
            IMPORTAR ARQUIVO
          </button>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3 text-decoration">
          <strong onClick={gerarModeloBaseImportacao}>BAIXAR MODELO</strong>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mt-4">
          <p className="pteste">
            <strong>Orientações</strong>
            <br />
            Para fazer o upload em massa do seu estoque, siga as orientações
            abaixo:
          </p>
          <ul>
            <li>
              Clique em "Baixar Modelo" para fazer o download da planilha de
              importação;
            </li>
            <li>A planilha deve estar no formato .xlsx;</li>
            <li>O arquivo não deve conter células mescladas;</li>
            <li>A primeira linha deve conter o cabeçalho das colunas;</li>
            <li>Deve haver somente uma aba no arquivo;</li>
            <li>
              Após a importação, veja o resultado de cada registro clicando nos
              números processados;
            </li>
            <li>
              <strong>
                No caso de erro no upload, será gerada uma planilha com o
                descritivo do erro de leitura na última coluna. Favor consultar,
                ajustar e carregar novamente.
              </strong>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt20">
        <PerfilSellerListOportunidadeLog
          response={logOportunidades}
          mudarPagina={mudarPaginaFilialSeller}
          exportarLogOportunidade={exportarResultadoLogOportunidade}
        />
      </div>
      <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
        <button
          className="col-sm-4 col-md-4 col-lg-4 mt20 buton-white-black-border"
          onClick={() => history.push("/seller/oportunidade")}
        >
          VOLTAR
        </button>
      </div>

      <Dialog
        open={confirmTotal > 1}
        onClose={() => {
          setConfirmTotal(0);
          setDocumento(null);
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className="mt30 mb30 ml30 mr30"
          style={{ paddingLeft: 50, paddingRight: 50 }}
        >
          <Typography variant="h6" fontWeight={800}>
            Confirmação
          </Typography>
          <Typography className="mt20 mb20" textAlign="center">
            Identificamos <b>{confirmTotal}</b> produtos com sucesso em sua
            lista. <br />
            Se preferir, podemos criar <b>{confirmTotal}</b> oportunidades
            <br />
            ou apenas <b>uma</b> com todos os itens.
          </Typography>
          <button
            type="button"
            className="col-sm-12 col-md-12 col-lg-12 mb10 buton-white-black-border "
            style={{ borderRadius: 5 }}
            onClick={() => importarArquivo(false)}
          >
            CRIAR <b>{confirmTotal}</b> OPORTUNIDADES
          </button>

          <button
            type="button"
            className="col-sm-12 col-md-12 col-lg-12 buton-white-black-border "
            style={{ borderRadius: 5 }}
            onClick={() => importarArquivo(true)}
          >
            APENAS <b>UMA</b> OPORTUNIDADE
          </button>
        </Box>
      </Dialog>
    </div>
  );
};

export default PerfilSellerImportacaoOportunidade;
